import { renderSlot as _renderSlot, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-029b4685")

_pushScopeId("data-v-029b4685")
const _hoisted_1 = { class: "p-10" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("—— ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_box = _resolveComponent("box")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_box, { class: "p-6 px-20 text-2xl bg-white" }, {
      default: _withId(() => [
        _createVNode("blockquote", null, [
          _renderSlot(_ctx.$slots, "quote")
        ]),
        _createVNode("cite", null, [
          _hoisted_2,
          _renderSlot(_ctx.$slots, "cite")
        ])
      ]),
      _: 3
    })
  ]))
})